import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBCsj2ZCHeyulQzjXiV9Hjabsz039DEU5E",
  authDomain: "yemek-login.firebaseapp.com",
  projectId: "yemek-login",
  storageBucket: "yemek-login.appspot.com",
  messagingSenderId: "526503180422",
  appId: "1:526503180422:web:8ef51ac9e05efde7dcf907",
  measurementId: "G-WWD6RBKNTP",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { db, auth, storage };
